const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20,2h-2V1c0-0.55-0.45-1-1-1s-1,0.45-1,1v1H8V1c0-0.55-0.45-1-1-1S6,0.45,6,1v1H4C1.79,2,0,3.79,0,6v14c0,2.21,1.79,4,4,4 h16c2.21,0,4-1.79,4-4V6C24,3.79,22.21,2,20,2z M2,6c0-1.1,0.9-2,2-2h2v1c0,0.55,0.45,1,1,1s1-0.45,1-1V4h8v1c0,0.55,0.45,1,1,1 s1-0.45,1-1V4h2c1.1,0,2,0.9,2,2v2h-4h-2h-4H8H6H2V6z M22,20c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V10h4h2h4h4h2h4V20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,13H5c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S7.55,13,7,13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,13h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S13.55,13,13,13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,14c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1s-0.45-1-1-1h-2C16.45,13,16,13.45,16,14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,17H5c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S7.55,17,7,17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,17h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S13.55,17,13,17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,17h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S19.55,17,19,17z"
}));

const SvgCalendar = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.6b2dcaa9.svg";
export { ForwardRef as ReactComponent };